"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpressViewState = /** @class */ (function () {
    function ExpressViewState() {
    }
    return ExpressViewState;
}());
exports.default = ExpressViewState;
//# sourceMappingURL=ExpressViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/ExpressViewState.js
// module id = 2347
// module chunks = 8